import React from "react";
import ReactDOM from "react-dom";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import * as redux from "redux";
import * as Comp from "../../../../components";
import { ComponentWithValidatedForm } from "../../../../components/validation";
import { ErrorCodes } from "../../../../domain";
import * as Forms from "../../../../forms";
import * as M from "../../../../models";
import { Api } from "../../../../services/Api";
import Settings from "../../../../settings";
import { AppState } from "../../../../store";
import { Paths } from "../../../../constants";

const mapStateToProps = (state: AppState, ownProps: OwnProps | undefined): ConnectedState => ({
    api: new Api(state),
});

const mapDispatchToProps = (dispatch: redux.Dispatch<AppState>): ConnectedDispatch => ({
});

interface OwnProps {
    onSuccess: (user: M.User.BasicProfile) => void;
    returnUrl: string;
    user?: M.User.BasicProfile;
}

interface ConnectedState {
    api: Api;
}

interface ConnectedDispatch {
}

interface OwnState {
}

class EmailFormComponent extends ComponentWithValidatedForm<ConnectedState & ConnectedDispatch & OwnProps, OwnState> {

    public constructor(props: any) {
        super(props);

        const formModel = new Forms.Account.SignInEmail();
        this.state = this.getInitialState(formModel);
    }

    public componentDidMount() {
        this.focusUsername();
    }

    public componentWillReceiveProps(nextProps: OwnProps) {
        if (this.props.user && !nextProps.user) {
            setTimeout(() => {
                this.focusUsername();
            }, 225);
        }
    }

    public render() {
        const buttons = this.state.formProcessing
            ? <div>
                <span className="btn btn-primary" style={{ float: "right" }}>&nbsp;&nbsp;<Comp.Generic.Icon icon="spinner fa-spin" />&nbsp;&nbsp;</span>
            </div>
            : <div>
                <Link className="btn btn-link" to={Paths.Account.CreateAccount + "?returnUrl=" + this.props.returnUrl}>Create an account</Link>
                <input className="btn btn-primary" style={{ float: "right" }} type="submit" value="Next" />
            </div>;

        return <Comp.Validation.ValidatedForm
            formComponent={this}
            model={this.state.formModel.data}
            onValidSubmit={async (model) => await this.onSubmit(model)}
            schema={this.state.formModel.rules}
            showErrorsOnBlur={false}
            showErrorsOnSubmit={false}
            ref={(ref) => this.form = ref}
        >
            <h1>Sign in</h1>
            <p>with your {Settings.ClientNameAbbreviation} account</p>

            <div className="form-row">
                <div className="form-field">
                    <Comp.Editors.EmailField formComponent={this} noFieldWrap css="txt" label="" name="username" placeholder="Email" />
                </div>
            </div>

            {buttons}

        </Comp.Validation.ValidatedForm>;
    }

    private focusUsername() {
        if (typeof document !== "undefined") {
            const parent = ReactDOM.findDOMNode(this);
            if (parent !== null && parent !== undefined) {
                const matches = parent.querySelectorAll(`[name="username"]`);
                if (matches.length) {
                    (matches[0] as HTMLInputElement).focus();
                }
            }
        }
    }

    private async onSubmit(model: Forms.Account.SignInEmailData) {
        this.toggleProcessing(true);

        const qp = { queryParams: { username: model.username, legacyCheck: true } };
        const result = await this.props.api.get<M.User.BasicProfile>(Api.endpoints.user.basicProfile, qp);

        if (result.isSuccess && result.data) {
            this.props.onSuccess(result.data);
        }
        else {
            this.handleValidationErrors([{
                inputName: "username",
                errors: [result.errorCode === ErrorCodes.Users_NotFound.id ? "We couldn't find your ASRS account" : result.errors.join("; ")],
            }]);
        }

        this.toggleProcessing(false);
    }
}

export const EmailForm: React.ComponentClass<OwnProps> = connect(mapStateToProps, mapDispatchToProps)(EmailFormComponent);



// WEBPACK FOOTER //
// ./src/containers/account/signin/components/EmailForm.tsx